export function useAppsUrls() {
  const deepAdminFeUrl = import.meta.env.VITE_DEEPADMIN_FRONTEND_BASE_URL
  // ACCOUNT
  function getDeepAdminAccountInSharesUrl(orgId: string) {
    const url = new URL(`${deepAdminFeUrl}/account/${orgId}/access/in-shares`)

    return url.toString()
  }

  // ORGANIZATION
  function getDeepAdminOrgInfoUrl(orgId: string) {
    const url = new URL(`${deepAdminFeUrl}/organizations/${orgId}/settings`)

    return url.toString()
  }

  function getDeepAdminOrgDeepBoxInSharesUrl(orgId: string) {
    const url = new URL(
      `${deepAdminFeUrl}/organizations/${orgId}/deepbox/in-shares`,
    )

    return url.toString()
  }

  function getDeepAdminOrgDeepBoxTypeUrl(orgId: string, typeId: string) {
    const url = new URL(
      `${deepAdminFeUrl}/organizations/${orgId}/deepbox/types/${typeId}/`,
    )

    return url.toString()
  }

  function getDeepAdminOrgDeepBoxTypeBoxUrl(
    orgId: string,
    typeId: string,
    boxId: string,
  ) {
    const url = new URL(
      `${deepAdminFeUrl}/organizations/${
        orgId
      }/deepbox/types/${typeId}/boxes/${boxId}/`,
    )

    return url.toString()
  }

  function getDeepAdminOrgDeepBoxTypeBoxAddressesUrl(
    orgId: string,
    typeId: string,
    boxId: string,
  ) {
    const url = new URL(
      `${deepAdminFeUrl}/organizations/${
        orgId
      }/deepbox/types/${typeId}/boxes/${boxId}/addresses`,
    )

    return url.toString()
  }

  function getDeepAdminOrgDeepBoxTypeTagsUrl(orgId: string, typeId: string) {
    const url = new URL(
      `${deepAdminFeUrl}/organizations/${orgId}/deepbox/types/${typeId}/tags`,
    )

    return url.toString()
  }

  function getDeepAdminOrgSubscriptionUrl(orgId: string) {
    const baseUrl = `${deepAdminFeUrl}/organizations/${orgId}/subscription`
    const iframePath = `/hybrid/organization/${orgId}/subscription`

    const encodedIframePath = encodeURIComponent(iframePath)

    return `${baseUrl}?iframe_path=${encodedIframePath}#subscription`
  }

  function getDeepAdminOrgSubscriptionInvoiceUrl(orgId: string) {
    const url = new URL(
      `${deepAdminFeUrl}/organizations/${orgId}/billing/invoices`,
    )

    return url.toString()
  }

  return {
    // DeepAdmin
    getDeepAdminOrgDeepBoxTypeBoxUrl,
    getDeepAdminOrgDeepBoxTypeUrl,
    getDeepAdminOrgDeepBoxInSharesUrl,
    getDeepAdminOrgDeepBoxTypeTagsUrl,
    getDeepAdminAccountInSharesUrl,
    getDeepAdminOrgDeepBoxTypeBoxAddressesUrl,
    getDeepAdminOrgInfoUrl,
    getDeepAdminOrgSubscriptionUrl,
    getDeepAdminOrgSubscriptionInvoiceUrl,
  }
}
